<template>
  <div class="monitor-board" v-show="panelShow">
    <Col span="24" :style="{padding: '5px'}">
      <Modal
        width="1000"
        v-model="addMonitorModal"
        title="创建监控图表"
        @on-cancel="cancelAddMonitorModal">
        <div class="">
          <Form inline :label-width="60">
            <FormItem label="设备类型">
              <Select v-model="optionForm.type" @on-change="getEndpointsFunc" style="min-width: 150px" filterable>
                <Option v-for="item in endpointTypeData"
                        :value="item.id"
                        :key="item.id"
                        :label="item.name"></Option>
              </Select>
            </FormItem>
            <FormItem label="设备">
              <Select v-model="optionForm.endpoint" multiple filterable @on-change="v=>{ getCounters(v, true)}" :label-in-value="true" style="width: 350px">
                <Option v-for="item in endpoint_list"
                        :value="item.id"
                        :key="item.id"
                        :label="item.endpoint"></Option>
              </Select>
            </FormItem>
            <FormItem label="标题">
              <Input v-model="optionForm.title" :maxlength="24" placeholder="最大24个字符" @on-change="draw" />
            </FormItem>
          </Form>
          <Row>
            <div style="height: 400px; border: 1px solid #ddd;overflow-x: auto;">
              <div style="width: 300px; height: 100%; background: #F2F2F2; border-right: 1px solid #ddd; float: left">
                <div style="line-height: 35px; padding-left: 10px">指标</div>
                <div>
                  <Table
                    ref="counter_table"
                    style="border: 0"
                    :show-header="false"
                    height="365"
                    @on-row-click="rowClick"
                    @on-selection-change="tableChange"
                    size="small"
                    :columns="counter_columns"
                    :data="counter_list"
                    no-data-text="请至少选择一个设备"
                    :loading="counter_loading"></Table>
                </div>
              </div>
              <div style="min-width: fit-content; height: 100%; padding-left: 300px">
                <div style="height: 35px; background: #F2F2F2; border-bottom: 1px solid #ddd">
                  <span style="line-height: 35px; padding-left: 10px">预览图表</span>
                </div>
                <div style="height: 100%; text-align: center;">
                  <div class="no-chart" style="line-height: 365px;" v-if="noChart">
                    <Icon type="md-analytics" size="180" style="color: #f1f1f1;" />
                  </div>
                  <div v-show="!noChart" id="add-monitor-chart-id" style="height: 365px; width: 666px"></div>
                </div>
              </div>
            </div>
          </Row>
        </div>
        <div slot="footer">
          <Button type="text" @click="cancelAddMonitorModal">取消</Button>
          <Button type="primary" @click="okAddMonitorModal(false)" :loading="add_monitor_loading">保存并继续创建</Button>
          <Button type="primary" @click="okAddMonitorModal" :loading="add_monitor_loading">确定</Button>
        </div>
      </Modal>
      <Drawer title="图表排序 (拖拽)" :closable="true" v-model="chartSortModal" width="414">
        <draggable :list="monitor_tmp" @end="handleEnd($event)">
          <div v-for="(item, index) in monitor_tmp" v-bind:key="`tmp_chart_${index}`" style="cursor: move" class="chartDiv">
            <Card>{{ item.title }}</Card>
          </div>
        </draggable>
      </Drawer>
      <Card shadow class="monitor-tmp-card home-card">
        <div slot="title">
          <Icon type="md-pulse" />
          <b> 监控大盘</b>
          <div style="float: right">
            <Tooltip content="自动刷新" placement="bottom">
              <i-switch v-model="autoRefresh" style="margin-right: 15px" size="small" @on-change="controlMonitorTimer">
                <span slot="open"></span>
                <span slot="close"></span>
              </i-switch>
            </Tooltip>
            <Tooltip content="刷新" placement="bottom">
              <a v-on:click="getMonitorDashboardData" style="margin-right: 15px" v-show="monitor_tmp.length">
                <Icon type="md-refresh" size="18" />
              </a>
            </Tooltip>
            <Tooltip content="排序" placement="bottom">
              <a v-on:click="chartSortModal=true" style="margin-right: 15px" v-show="monitor_tmp.length > 1">
                <Icon type="md-funnel" size="18" />
              </a>
            </Tooltip>
            <Button type="primary" size="small" v-show="monitor_tmp.length" @click="addMonitorModalOpen">添加监控图表</Button>
          </div>
        </div>
        <Alert type="warning" show-icon v-if="error">获取监控大盘数据失败</Alert>
        <div v-else style="overflow:hidden;" class="monitor-tmp-body">
          <div class="no-tmp" v-show="!monitor_tmp.length">
            <div class="no-tmp-border" v-on:click="addMonitorModalOpen">
              <Icon class="no-tmp-border-icon" type="ios-add" size="40" />
            </div>
          </div>
          <div v-for="(item, index) in monitor_tmp" v-bind:key="`tmp_chart_${index}`">
            <Col :xs="24" :sm="24" :md="24" :lg="item.span" :style="{padding: '0 5px 10px 5px'}">
              <Card>
                <p slot="title">
                  <span>{{ item.title }}</span>
                  <span :style="{float : 'right'}">
                  <Dropdown @on-click="v => { changeChartSize(v, index) }" transfer>
                    <a href="javascript:void(0)" style="margin-right: 10px;" class="chartBtn">
                      <Icon type="md-resize" size="16" />
                    </a>
                    <DropdownMenu slot="list">
                      <DropdownItem :name="6" :selected="item.span === 6">1 : 4</DropdownItem>
                      <DropdownItem :name="8" :selected="item.span === 8">1 : 3</DropdownItem>
                      <DropdownItem :name="12" :selected="item.span === 12">1 : 2</DropdownItem>
                      <DropdownItem :name="24" :selected="item.span === 24">1 : 1</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                  <Tooltip content="全屏" placement="bottom">
                    <a type="text" v-on:click="chartScreen(item)" style="margin-right: 10px;" class="chartBtn">
                      <Icon type="md-expand" size="16" />
                    </a>
                  </Tooltip>
                  <Dropdown @on-click="v => { chartsTools(v, index, item) }" transfer>
                    <a href="javascript:void(0)" class="chartBtn">
                      <Icon type="md-more" size="16" />
                    </a>
                    <DropdownMenu slot="list">
                      <DropdownItem name="edit">编辑</DropdownItem>
                      <DropdownItem name="remove">
                        <span style="color: red;">删除</span>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </span>
                </p>
                <spin fix v-show="chartLoading">
                  <icon type="ios-loading" size=18 class="demo-spin-icon-load"></icon>
                </spin>
                <div :id="'graph_id_' + index" :style="getChartHeight(item.span)"></div>
              </Card>
            </Col>
          </div>
        </div>
      </Card>
    </Col>
  </div>
</template>

<script>
import { getEndpointType, getAllEndpoint, getCounterListByEndpointIds, getEndpointMonitorData,
  getMonitorConfig, getMonitorDashboard, updateMonitorDashboard, deleteMonitorDashboard } from '@/api/monitor'
import eventVue from '../../../view/monitor/components/event.js'
import echarts from '../../../view/monitor/components/echarts-use.js'
import draggable from 'vuedraggable'
import { valueTranUnit } from '@/libs/tools'

let viewOption = {
  title: {
    text: '',
    x: 'left',
    left: 10,
    top: 10
  },
  grid: {
    x: 40,
    x2: 40,
    left: 60
  },
  tooltip: {
    trigger: 'axis',
    formatter: function (params) {
      let str = '<div>' + params[0].axisValueLabel + '</div>'
      for (let i = 0; i < params.length; i++) {
        let value = params[i].data[1]
        let reValue = valueTranUnit(value, 1, '')
        str += '<div class="circle_tooltip" style="background-color: ' + params[i].color + '"></div>' +
          '<span>' + params[i].seriesName + '</span> : <span>' + (value !== null ? reValue : '无数据') + '</span><br/>'
      }
      return str
    }
  },
  legend: {
    x: 'center',
    y: 'bottom',
    type: 'scroll',
    width: '90%',
    icon: 'rect',
    itemWidth: 10,
    itemHeight: 10,
    itemGap: 15
  },
  xAxis: {
    type: 'time',
    splitLine: {
      show: false
    },
    axisLabel: {
      formatter: function (value, index) {
        let date = new Date(value)
        let texts = [(date.getHours()), date.getMinutes()]

        return texts.join(':')
      }
    }
  },
  yAxis: {
    type: 'value',
    splitLine: {
      show: true
    },
    axisLabel: {
      formatter: function (value) {
        return valueTranUnit(value, 0)
      }
    }
  },
  series: []
}

let option = {
  title: {
    text: ''
  },
  grid: {
    x: 40,
    x2: 40,
    left: 60,
    top: 40
  },
  tooltip: {
    trigger: 'axis',
    formatter: function (params) {
      let str = '<div>' + params[0].axisValueLabel + '</div>'
      for (let i = 0; i < params.length; i++) {
        let value = params[i].data[1]
        let reValue = valueTranUnit(value, 1, '')
        str += '<div class="circle_tooltip" style="background-color: ' + params[i].color + '"></div>' +
          '<span>' + params[i].seriesName + '</span> : <span>' + (value !== null ? reValue : '无数据') + '</span><br/>'
      }
      return str
    }
  },
  legend: {
    x: 'center',
    y: 'bottom',
    type: 'scroll',
    width: '90%',
    icon: 'rect',
    itemWidth: 10,
    itemHeight: 10,
    itemGap: 15
  },
  xAxis: {
    type: 'time',
    splitLine: {
      show: false
    },
    axisLabel: {
      formatter: function (value, index) {
        let date = new Date(value)
        let texts = [(date.getHours()), date.getMinutes()]

        return texts.join(':')
      }
    }
  },
  yAxis: {
    type: 'value',
    splitLine: {
      show: true
    },
    axisLabel: {
      formatter: function (value) {
        return valueTranUnit(value, 0)
      }
    }
  },
  series: []
}

export default {
  name: 'monitor-board',
  components: {
    draggable
  },
  props: {
    panelShow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      myTemId: '',
      monitorList: [],
      addMonitorModal: false,
      optionForm: {
        index: -1,
        span: 8,
        type: '',
        endpoint: [],
        data: {},
        title: ''
      },
      counter_query: '',
      endpointTypeData: [],
      endpoint_list: [],
      angle_list: [
        {
          value: 'endpoint',
          label: '设备视角'
        },
        {
          value: 'counter',
          label: '指标视角'
        },
        {
          value: 'merge',
          label: '组合视角'
        }
      ],
      cf_list: [
        {
          value: 'AVERAGE',
          label: '平均值'
        },
        {
          value: 'MAX',
          label: '最大值'
        },
        {
          value: 'MIN',
          label: '最小值'
        }
      ],
      endpoint_label_list: [],
      counter_columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '指标',
          render: (h, params) => {
            let result = params.row.counter
            if (params.row.describe) {
              result = params.row.describe + '(' + result + ')'
            }
            return h('span', result)
          }
        }
      ],
      counter_list: [],
      counter_ids_list: [],
      counter_selected_list: [],
      counter_loading: false,
      noChart: true,
      graphFilter: {
        angle: 'endpoint',
        cf: 'AVERAGE',
        sum: false,
        sumonly: false,
        selectTime: '3600',
        start: '',
        end: ''
      },
      preViewLoading: false,
      monitorTheme: 'dark',
      add_monitor_loading: false,
      monitor_tmp: [],
      options: { draggable: '.chartDiv' },
      chartSortModal: false,
      chartLoading: false,
      error: false,
      timer: null,
      autoRefresh: true
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  },
  watch: {
    panelShow () {
      if (this.panelShow) {
        this.getMonitorDashboardData()
        this.getEndpointTypeData()
        this.getTheme()
        clearInterval(this.timer)
        this.timer = null
        this.setTimer()
      }
    }
  },
  created: function () {
    if (this.panelShow) {
      this.getMonitorDashboardData()
      this.getEndpointTypeData()
      this.getTheme()
      clearInterval(this.timer)
      this.timer = null
      this.setTimer()
    }
  },
  methods: {
    // 获取图表列表数据
    getMonitorDashboardData (loadingShow = true) {
      this.error = false
      getMonitorDashboard().then(res => {
        this.monitor_tmp = res.data.data
        this.myTemId = res.data.id
        for (let i in this.monitor_tmp) {
          this.getGraphData(this.monitor_tmp[i].req_data, 'graph_id_' + i, this.monitor_tmp[i].span, option, loadingShow)
        }
      }).catch(errO => {
        this.error = true
      })
    },
    // 图表工具
    chartsTools (name, index, item) {
      switch (name) {
        case 'edit':
          this.optionForm.index = index
          this.optionForm.type = item.endpoint_type
          this.optionForm.span = item.span
          this.optionForm.title = item.title
          this.getEndpointsFunc(item.endpoint_type)
          this.addMonitorModalOpen()
          break
        case 'remove':
          this.$Modal.confirm({
            title: '提示',
            content: '确认要删除该图表「' + item.title + '」吗？',
            onOk: () => {
              this.removeTmp(index)
            }
          })
      }
    },
    // 移除图表
    removeTmp (index) {
      deleteMonitorDashboard({ 'index': index }, this.myTemId).then(res => {
        this.getMonitorDashboardData()
      })
    },
    // 拖拽图表成功后
    handleEnd (event) {
      event.preventDefault()
      updateMonitorDashboard({'data': this.monitor_tmp}, this.myTemId).then(res => {
        this.getMonitorDashboardData()
        for (let i in this.monitor_tmp) {
          echarts.init(document.getElementById('graph_id_' + i), this.monitorTheme).resize()
        }
      })
    },
    // 获取监控数据
    getGraphData (reqData, graphId, span = 24, mOption = option, loadingShow = true) {
      let that = this
      if (loadingShow) {
        that.chartLoading = true
      }
      getEndpointMonitorData(reqData).then(res => {
        let result = res.data
        if (result.code === 200) {
          let data = result.data.series
          let dseries = []
          let haveArea = false
          let monitorTheme = this.monitorTheme
          if (monitorTheme.endsWith('-line')) {
            monitorTheme = monitorTheme.split('-line')[0]
          } else {
            haveArea = true
          }
          for (let v in data) {
            let dSeriesConfig = {
              name: data[v].name,
              data: data[v].data,
              type: 'line',
              symbolSize: 0,
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 1
                  }
                }
              }
            }
            if (haveArea) {
              dSeriesConfig.areaStyle = {
                opacity: 0.2
              }
            }
            dseries.push(dSeriesConfig)
          }
          if (span === 6) {
            mOption.yAxis.splitNumber = 2
          } else if (span === 8) {
            mOption.yAxis.splitNumber = 3
          } else if (span === 12) {
            mOption.yAxis.splitNumber = 4
          } else {
            mOption.yAxis.splitNumber = 5
          }
          mOption.title.text = ''
          mOption.series = dseries
          let graphLine = echarts.init(document.getElementById(graphId), monitorTheme)
          window.addEventListener('resize', function () {
            graphLine.resize()
          })
          graphLine.clear()
          graphLine.setOption(mOption, true)
          this.chartLoading = false
        } else {
          this.error = true
          this.preViewLoading = false
          this.chartLoading = false
          console.log(result.msg)
        }
      }).catch(res => {
        this.error = true
        this.preViewLoading = false
        this.chartLoading = false
        if (res.request) {
          console.log(res.request.responseText)
        }
      })
    },
    // 打开新图表窗口
    addMonitorModalOpen () {
      this.addMonitorModal = true
    },
    // 确定增加新图表
    okAddMonitorModal (close = true) {
      if (this.optionForm.endpoint.length > 0 && this.counter_selected_list.length > 0) {
        let reqData = {
          'last': this.graphFilter.selectTime,
          'cf': this.graphFilter.cf,
          'sum': this.graphFilter.sum,
          'sumonly': this.graphFilter.sumonly,
          'start': this.graphFilter.start,
          'end': this.graphFilter.end,
          'endpoints': this.endpoint_label_list,
          'counters': this.counter_selected_list
        }
        if (this.optionForm.endpoint.length > 1 && this.counter_selected_list.length > 1) {
          reqData.angle = 'merge'
        } else if (this.optionForm.endpoint.length > 1) {
          reqData.angle = 'endpoint'
        } else if (this.counter_selected_list.length > 1) {
          reqData.angle = 'counter'
        } else if (this.optionForm.endpoint.length === 1 && this.counter_selected_list.length === 1) {
          reqData.angle = 'counter'
        } else {
          this.$Notice.error({
            title: '操作失败, 请选择设备和指标'
          })
        }
        let data = {
          title: viewOption.title.text,
          span: this.optionForm.span,
          endpoint_type: this.optionForm.type,
          endpoint_ids: this.optionForm.endpoint,
          counters_ids: this.counter_ids_list,
          req_data: reqData
        }
        this.add_monitor_loading = true
        let params = { data: data }
        let paramsId = 0
        if (this.optionForm.index > -1) {
          params.index = this.optionForm.index
          paramsId = this.myTemId
        }
        updateMonitorDashboard(params, paramsId).then(res => {
          this.add_monitor_loading = false
          this.$Notice.success({
            title: '操作成功'
          })
          this.optionForm.index = -1
          this.getMonitorDashboardData()
          if (close) {
            this.cancelAddMonitorModal()
          }
        }).catch(errO => {
          this.add_monitor_loading = false
          this.$Notice.error({
            title: '操作失败'
          })
        })
      } else {
        this.$Notice.error({
          title: '操作失败, 请选择设备和指标'
        })
      }
    },
    // 关闭增加新图表窗口
    cancelAddMonitorModal () {
      this.optionForm = {
        span: 8,
        type: '',
        endpoint: [],
        data: {},
        index: -1
      }
      this.counter_query = ''
      this.addMonitorModal = false
    },
    // 获取设备类型
    getEndpointTypeData () {
      getEndpointType().then(res => {
        this.endpointTypeData = res.data
      })
    },
    // 根据设备类型获取设备
    getEndpointsFunc (typeId) {
      this.noChart = true
      this.endpoint_list = []
      this.optionForm.endpoint = []
      if (!typeId) {
        return false
      }
      let params = {
        type: typeId
      }
      getAllEndpoint(params).then(res => {
        this.endpoint_list = res.data
        if (this.optionForm.index > -1) {
          this.optionForm.endpoint = this.monitor_tmp[this.optionForm.index].endpoint_ids
        }
      }).catch(res => {
        if (res.request) {
          console.log(res.request.responseText)
        }
      })
    },
    // 根据设备获取指标
    getCounters (mdata, reset = false) {
      this.noChart = true
      this.counter_list = []
      this.counter_selected_list = []
      if (reset) {
        this.endpoint_label_list = []
        this.counter_query = ''
        for (let i in mdata) {
          this.endpoint_label_list.push(mdata[i].label)
        }
        if (mdata.length <= 0) {
          return false
        }
      }
      let reqData = {
        query: this.counter_query,
        endpoint_list: this.optionForm.endpoint
      }
      this.counter_loading = true
      getCounterListByEndpointIds(reqData).then(res => {
        this.counter_list = res.data.data
        this.counter_loading = false
      }).catch(res => {
        this.counter_loading = false
        if (res.request) {
          console.log('请求状态码:' + res.request.status + ', ' + res.request.responseText)
        }
      }).finally(errO => {
        if (this.optionForm.index > -1) {
          this.selectRowByIds(this.monitor_tmp[this.optionForm.index].counters_ids)
        }
      })
    },
    selectRowByIds (counterIds) {
      for (let i in this.$refs.counter_table.objData) {
        if (counterIds.indexOf(this.$refs.counter_table.objData[i].id) > -1) {
          this.counter_selected_list.push(this.$refs.counter_table.objData[i].counter)
          this.counter_ids_list.push(this.$refs.counter_table.objData[i].id)
          this.$refs.counter_table.objData[i]._isChecked = true
        }
      }
      this.noChart = true
      this.draw()
    },
    // 点击指标行
    rowClick (data, index) {
      let that = this
      that.$refs.counter_table.objData[index]._isChecked = !that.$refs.counter_table.objData[index]._isChecked
      if (that.$refs.counter_table.objData[index]._isChecked) {
        that.counter_selected_list.push(data.counter)
        that.counter_ids_list.push(data.id)
      } else {
        that.counter_ids_list = []
        that.counter_selected_list = []
        for (let i in that.$refs.counter_table.objData) {
          if (that.$refs.counter_table.objData[i]._isChecked) {
            that.counter_selected_list.push(that.$refs.counter_table.objData[i].counter)
            that.counter_ids_list.push(that.$refs.counter_table.objData[i].id)
          }
        }
      }
      this.noChart = true
      this.draw()
    },
    // 点击指标选择框
    tableChange (data) {
      let that = this
      that.counter_ids_list = []
      that.counter_selected_list = []
      for (let i in data) {
        that.counter_ids_list.push(data[i].id)
        that.counter_selected_list.push(data[i].counter)
      }
      this.noChart = true
      this.draw()
    },
    // 出图
    draw () {
      let reqData = {
        'last': this.graphFilter.selectTime,
        'cf': this.graphFilter.cf,
        'sum': this.graphFilter.sum,
        'sumonly': this.graphFilter.sumonly,
        'start': this.graphFilter.start,
        'end': this.graphFilter.end,
        'endpoints': this.endpoint_label_list,
        'counters': this.counter_selected_list
      }
      if (this.optionForm.endpoint.length > 1 && this.counter_selected_list.length > 1) {
        reqData.angle = 'merge'
      } else if (this.optionForm.endpoint.length > 1) {
        reqData.angle = 'endpoint'
      } else if (this.counter_selected_list.length > 1) {
        reqData.angle = 'counter'
      } else if (this.optionForm.endpoint.length === 1 && this.counter_selected_list.length === 1) {
        reqData.angle = 'counter'
      } else {
        return false
      }
      this.optionForm.data = reqData
      if (!this.optionForm.title) {
        viewOption.title.text = this.endpoint_label_list.join('|')
      } else {
        viewOption.title.text = this.optionForm.title
      }
      this.newGraphData(reqData, 'add-monitor-chart-id')
    },
    // 获取出图数据
    newGraphData (reqData, graphId) {
      this.preViewLoading = true
      getEndpointMonitorData(reqData).then(res => {
        let result = res.data
        if (result.code === 200) {
          if (result.data.title) {
            reqData.title = result.data.title
          }
          let data = result.data.series
          let dseries = []
          let haveArea = false
          let monitorTheme = this.monitorTheme
          if (monitorTheme.endsWith('-line')) {
            monitorTheme = monitorTheme.split('-line')[0]
          } else {
            haveArea = true
          }
          for (let v in data) {
            let dSeriesConfig = {
              name: data[v].name,
              data: data[v].data,
              type: 'line',
              symbolSize: 0,
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 1
                  }
                }
              }
            }
            if (haveArea) {
              dSeriesConfig.areaStyle = {
                opacity: 0.2
              }
            }
            dseries.push(dSeriesConfig)
          }
          viewOption.series = dseries
          this.noChart = false
          this.preViewLoading = false
          let graphLine = echarts.init(document.getElementById(graphId), monitorTheme)
          window.addEventListener('resize', function () {
            graphLine.resize()
          })
          graphLine.clear()
          graphLine.setOption(viewOption, true)
        } else {
          this.preViewLoading = false
          console.log(result.msg)
        }
      }).catch(res => {
        this.preViewLoading = false
        if (res.request) {
          console.log(res.request.responseText)
        }
      })
    },
    // 获取主题
    getTheme () {
      getMonitorConfig().then(res => {
        let result = res.data
        if (result.code === 200) {
          this.monitorTheme = result.data.theme
        }
      })
    },
    // 全屏放大图表
    chartScreen (data) {
      eventVue.$emit('openChartFun', data)
      // this.$refs.alarmChartModal.openChartModal(data)
    },
    // 修改图表大小
    changeChartSize (size, index) {
      this.monitor_tmp[index].span = size
      updateMonitorDashboard({'data': this.monitor_tmp}, this.myTemId).then(res => {
        echarts.init(document.getElementById('graph_id_' + index), this.monitorTheme).setOption(option, true)
        echarts.init(document.getElementById('graph_id_' + index), this.monitorTheme).resize()
        this.getMonitorDashboardData()
      })
    },
    // 获取图表高度
    getChartHeight (span) {
      let height = 200
      if (span === 8) {
        height = 300
      } else if (span === 12) {
        height = 350
      } else if (span === 24) {
        height = 450
      }
      return { 'height': height + 'px' }
    },
    // 自动刷新
    setTimer () {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.getMonitorDashboardData(false)
        }, 60000)
      }
    },
    // 定时刷新控制器
    controlMonitorTimer () {
      if (this.autoRefresh) {
        this.setTimer()
      } else {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .no-tmp {
    height: 200px;
  }
  .no-tmp .no-tmp-border {
    height: 100%;
    width: 100%;
    border-radius: 20px;
    border: 1px dashed #cccccc;
    text-align: center;
  }
  .no-tmp-border:hover {
    color: #2d8cf0;
    border: 1px dashed #2d8cf0;
    cursor: pointer;
  }
  .no-tmp .no-tmp-border .no-tmp-border-icon {
    position:absolute;
    top: 50%;
  }

  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .demo-spin-col{
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }

  .chartBtn {
    color: #999;
  }
  .chartBtn:hover {
    color: #2d8cf0;
  }
  .chartDiv {
    margin-bottom: 3px;
  }
  .ivu-card-head span {
    font-weight: normal;
  }
</style>
<style lang="less">
  .monitor-tmp-body .ivu-card-body {
    padding: 0 !important;
  }
  .monitor-tmp-body .ivu-card-head {
    padding-top: 7px !important;
    padding-bottom: 7px !important;
    background-color: #F2F2F2
  }
</style>
<style scoped>
/*mob-style*/
.ivu-select{
  max-width: 100%;
}
</style>
